<h2 class="block sm:hidden pl-4 pt-4">{{ this.stateManagementService.pageHeading() || "Claim-it Marketplace" }}</h2>
<div class="flex items-center p-4 top-[80px] bg-agentium_white-backdrop z-10" [ngClass]="showDateFilter ? 'sticky' : ''">
</div>
<!-- Data-Enriched Referral tooltip -->
<ng-template #enrichedDataToolTip>
  <div class="p-3 space-y-2 absolute z-50 inline-block text-sm text-white transition-opacity duration-300 bg-momentum-deep_purple border border-gray-200 rounded-lg shadow-sm w-full sm:w-80"
  >
    A Data-Enriched Referral includes extra business insights that help agents connect more effectively and deliver faster, more accurate quotes.
    <a href="https://www.momentumedge.com/help/data-enriched-insurance-referrals/" target="_blank" class="border-b border-white hover:border-b-0"
    >Learn more <span class="text-[10px] inline-block -scale-x-100 -ml-[2px]">&#8598;</span></a
    >
  </div>
</ng-template>
<div class="pb-4 px-4 relative">
  <app-details-panel *ngIf="enableDetailsPanel" [selectedOpportunityId]="selectedReferral != null ? selectedReferral.opportunityId : null"></app-details-panel>
  <div class="table-wrapper">
    <app-public-claim-modal [openModalObservable]="openModal$.asObservable()"></app-public-claim-modal>
    <div class="table-wrapper relative">
      <table cdk-table [dataSource]="dataSource" (contentChanged)="finishedLoading()" class="w-full">
        <thead>

        <!-- Acquired Date Column -->
        <ng-container cdkColumnDef="lastModDate">
          <th cdk-header-cell *cdkHeaderCellDef (click)="dataSource.sort('lastModDate')" class="pb-2 pt-3 pl-6 pr-4 cursor-pointer font-semibold whitespace-nowrap">
            Acquired
            <span *ngIf="dataSource.sortField === 'lastModDate'">
                {{ dataSource.sortOrder === "asc" ? "↑" : dataSource.sortOrder === "desc" ? "↓" : "" }}
              </span>
          </th>
          <td cdk-cell *cdkCellDef="let element" class="py-2 pl-6 pr-4 text-slate-600">
            <div *ngIf="UtilityService.isToday(element.lastModDate)">
              <span class="inline-block items-center rounded-full px-4 py-1 my-1 text-xs font-medium ring-inset bg-green-500 text-white">
                Today
              </span>
            </div>
            <div class="pl-2">
              <div *ngIf="!UtilityService.isToday(element.lastModDate)">
                {{ element.lastModDate | date: "shortDate" }}
              </div>
              <div>
                {{ element.addDate | date: "shortTime" }}
              </div>
            </div>
          </td>
        </ng-container>

        <!-- Type Column -->
        <ng-container cdkColumnDef="type">
          <th cdk-header-cell *cdkHeaderCellDef class="pb-2 pt-3 pl-2 pr-10 text-center font-semibold whitespace-nowrap">Type</th>
          <td cdk-cell *cdkCellDef="let element" class="py-2 pl-2 pr-10 text-slate-600 text-center">
            {{ element.opportunityType }}
          </td>
        </ng-container>

        <!-- Name Column -->
        <ng-container cdkColumnDef="name">
          <th cdk-header-cell *cdkHeaderCellDef (click)="dataSource.sort('lastName')" class="pb-2 pt-3 pr-4 cursor-pointer font-semibold whitespace-nowrap">
            Name
            <span *ngIf="dataSource.sortField === 'lastName'">
                {{ dataSource.sortOrder === "asc" ? "↑" : dataSource.sortOrder === "desc" ? "↓" : "" }}
              </span>
          </th>
          <td cdk-cell *cdkCellDef="let element" class="py-2 pr-8">{{ concatenateName(element.firstName, element.lastName) }}</td>
        </ng-container>

        <!-- Phone Column -->
        <ng-container cdkColumnDef="phone">
          <th cdk-header-cell *cdkHeaderCellDef (click)="dataSource.sort('phone')" class="pb-2 pt-3 pr-4 cursor-pointer font-semibold whitespace-nowrap">
            Phone
            <span *ngIf="dataSource.sortField === 'phone'">
                {{ dataSource.sortOrder === "asc" ? "↑" : dataSource.sortOrder === "desc" ? "↓" : "" }}
              </span>
          </th>
          <td cdk-cell *cdkCellDef="let element" class="py-2 pr-8">{{ element.phone }}</td>
        </ng-container>

        <!-- Email Column -->
        <ng-container cdkColumnDef="email">
          <th cdk-header-cell *cdkHeaderCellDef (click)="dataSource.sort('email')" class="pb-2 pt-3 pr-4 cursor-pointer font-semibold whitespace-nowrap">
            Email
            <span *ngIf="dataSource.sortField === 'email'">
                {{ dataSource.sortOrder === "asc" ? "↑" : dataSource.sortOrder === "desc" ? "↓" : "" }}
              </span>
          </th>
          <td cdk-cell *cdkCellDef="let element" class="py-2 pr-8">{{ element.email }}</td>
        </ng-container>

        <!-- Location Column -->
        <ng-container cdkColumnDef="city">
          <th cdk-header-cell *cdkHeaderCellDef (click)="dataSource.sort('city')" class="pb-2 pt-3 pr-8 cursor-pointer font-semibold whitespace-nowrap min-w-24">
            City, State
            <span *ngIf="dataSource.sortField === 'city'">
                {{ dataSource.sortOrder === "asc" ? "↑" : dataSource.sortOrder === "desc" ? "↓" : "" }}
              </span>
          </th>
          <td cdk-cell *cdkCellDef="let element" class="py-2 pr-8 min-w-24">{{ element.city == null ? "" : element.city + ", " + element.state }}</td>
        </ng-container>

        <!-- Category Column -->
        <ng-container cdkColumnDef="category">
          <th cdk-header-cell *cdkHeaderCellDef (click)="dataSource.sort('category')" class="pb-2 pt-3 pr-4 cursor-pointer font-semibold whitespace-nowrap">
            Category
            <span *ngIf="dataSource.sortField === 'category'">
                {{ dataSource.sortOrder === "asc" ? "↑" : dataSource.sortOrder === "desc" ? "↓" : "" }}
              </span>
          </th>
          <td cdk-cell *cdkCellDef="let element" class="py-2 pr-8">{{ element.category }}
            <div *ngIf="element?.opportunityExternalLinks?.length">
              <button
                type="button"
                class="my-1 inline-flex items-center text-xs text-slate-600 leading-5 text-nowrap py-0.5 px-3 rounded-full bg-slate-200 focus:outline-none focus:ring-0 focus:ring-transparent"
                [customCdkTooltip]="enrichedDataToolTip"
                customCdkTooltipPosition="below"
                customCdkTooltipClass="data-enriched-referral-tooltip-panel"
                aria-label="Data-Enriched Referral"
                (click)="$event.stopPropagation()"
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="10" height="14" viewBox="0 0 11 15" class="mr-1 relative -top-[1px]">
                  <path
                    class="fill-slate-600"
                    d="M5.98.33c.44,0,.86.17,1.18.49l2.36,2.36c.31.31.49.74.49,1.18v7.64c0,.92-.75,1.67-1.67,1.67H1.67C.75,13.67,0,12.92,0,12V2C0,1.08.75.33,1.67.33h4.31ZM8.33,12.42c.23,0,.42-.19.42-.42v-7.5h-2.08c-.46,0-.83-.37-.83-.83V1.58H1.67c-.23,0-.42.19-.42.42v10c0,.23.19.42.42.42h6.67ZM4.75,10.08c-.12.12-.28.18-.44.18s-.33-.07-.44-.18l-1.39-1.39c-.24-.24-.24-.64,0-.88.24-.24.64-.24.88,0l.95.95,2.34-2.34c.24-.24.64-.24.88,0,.24.24.24.64,0,.88l-2.78,2.78Z"
                  />
                </svg>
                Data-Enriched Referral
              </button>
            </div>
          </td>
        </ng-container>

        <!-- Lines of Business Column -->
        <ng-container cdkColumnDef="businessLines">
          <th cdk-header-cell *cdkHeaderCellDef class="pb-2 pt-3 pr-2 font-semibold whitespace-nowrap min-w-80">Line of Business</th>
          <td cdk-cell *cdkCellDef="let element" class="py-2 pr-2 pl-0 min-w-[200px]">{{ element.businessLines.join(", ") }}</td>
        </ng-container>
        </thead>
        <tbody>
        <tr cdk-header-row *cdkHeaderRowDef="columnsToDisplay" class="font-medium text-left text-slate-500 shadow"></tr>
        <tr
          cdk-row
          *cdkRowDef="let row; columns: columnsToDisplay; let index = index"
          class="border-t hover:bg-agentium_blue-light hover:shadow text-slate-600"
          (click)="setSelectedReferral(row, index)"
          [ngClass]="(enableDetailsPanel ? 'hover:cursor-pointer ' : '') + (selectedIndex == index ? 'bg-agentium_blue-light shadow-md border-t border-b border-momentum-deep_purple' : '')"
        ></tr>
        </tbody>
      </table>
      <div class="w-full flex justify-center">
        <fa-icon *ngIf="isLoading" [icon]="faGear" animation="spin" class="p-4 text-slate-600" size="2xl"></fa-icon>
      </div>
    </div>
  </div>
  <div class="flex flex-row py-2 justify-end pb-5" [ngClass]="showDateFilter == true ? 'lg:pr-16' : 'lg:pr-3'">
    <!-- Help text -->

    <div class="inline-flex mt-2 xs:mt-0 px-4 text-indigo-950">
      <span class="text-sm content-center mx-2 inline-block pr-2">
        Showing <span class="font-semibold text-a">{{ dataSource.pageNumber * dataSource.pageSize + (dataSource.numberOfElements > 0 ? 1 : 0) }}</span> to
        <span class="font-semibold">{{ dataSource.pageNumber * dataSource.pageSize + dataSource.numberOfElements }}</span> of <span class="font-semibold">{{ dataSource.totalEntries }}</span> Referrals
      </span>
      <div class="flex">
        <span class="underline hover:no-underline cursor-pointer" (click)="dataSource.updatePage(-1)"> Previous</span>
        <span class="px-2">|</span>
        <span class="underline hover:no-underline cursor-pointer" (click)="dataSource.updatePage(1)"> Next </span>
      </div>
    </div>
  </div>
</div>
